import request from '@/router/axios';
/**
 * 列表
 * @param { Object } data 
 * @param { String } data.text 内容
 * @param { String | Number } data.status 是否已推送 1-否 2-是
 * @param { Number } current 当前页
 * @param { Number } size 每页条数
 * @returns 
 */
export const getLibraryList = (current = 1, size = 10, data = {}) => {
  return request({
    url: `/api/blade-loanLibrary/loanLibrary/page?current=${current}&size=${size}`,
    method: 'post',
    data: {
      ...data
    }
  })
}

/**
 * 新增
 * @param { Object } data 
 * @param { String } data.text 内容
 * @returns 
 */
export const add = (data) => {
  return request({
    url: '/api/blade-loanLibrary/loanLibrary/save',
    method: 'post',
    data: {
      ...data
    }
  })
}

/**
 * 批量新增
 * @param { Array<Object> } list 列表
 * @param { String } list[].text 内容
 * @returns 
 */
export const addList = (list) => {
  return request({
    url: '/api/blade-loanLibrary/loanLibrary/batch',
    method: 'post',
    data: [...list]
  })
}

/**
 * 修改
 * @param { Object } data 
 * @param { String | Number } data.id 主键
 * @param { String } data.text 内容
 * @returns 
 */
export const update = (data) => {
  return request({
    url: '/api/blade-loanLibrary/loanLibrary/update',
    method: 'post',
    data: {
      ...data
    }
  })
}

/**
 * 删除
 * @param { Number } ids 主键id 
 * @returns
 */
export const remove = (ids) => {
  return request({
    url: '/api/blade-loanLibrary/loanLibrary/remove',
    method: 'post',
    params: {
      ids
    }
  })
}